document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth >= 1000) {
       

      /* Animation - toRight */
      const left_arm = document.querySelectorAll('.left_arm');
      observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
              if(entry.intersectionRatio > 0) {
                  entry.target.style.animation = `left_arm .8s forwards ease-out`;
              } else {
                  entry.target.style.animation = 'none';
              }
          })
      })
      left_arm.forEach(left => {
          observer.observe(left)
      })
      /* Animation - toLeft */
      const right_arm = document.querySelectorAll('.right_arm');
      observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
              if(entry.intersectionRatio > 0) {
                  entry.target.style.animation = `right_arm .8s forwards ease-out`;
              } else {
                  entry.target.style.animation = 'none';
              }
          })
      })
      right_arm.forEach(left => {
          observer.observe(left)
      })
      /* Animation - toBottom */
      const bottom_arm = document.querySelectorAll('.bottom_arm');
      observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
              if(entry.intersectionRatio > 0) {
                  entry.target.style.animation = `bottom_arm .8s forwards ease-out`;
              } else {
                  entry.target.style.animation = 'none';
              }
          })
      })
      bottom_arm.forEach(left => {
          observer.observe(left)
      })
      /* Animation - toTop */
      const top_arm = document.querySelectorAll('.top_arm');
      observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
              if(entry.intersectionRatio > 0) {
                  entry.target.style.animation = `top_arm .8s forwards ease-out`;
              } else {
                  entry.target.style.animation = 'none';
              }
          })
      })
      top_arm.forEach(left => {
          observer.observe(left)
      })
      

    }
});